import { apiJson } from "./client";

export function getMatchChat(matchId) {
  return apiJson(`/api/chat/${matchId}`, { method: "GET" });
}

export function postMatchChatMessage(matchId, messageText) {
  return apiJson(`/api/chat/${matchId}`, {
    method: "POST",
    rawBody: JSON.stringify(messageText)
  });
}
